/* ===== hot-product-main ===== */
(function () {
  var root = document.querySelector('[data-hot-pdp]');
  if (!root) return;

  var handle = root.getAttribute('data-product-handle');
  var mainImageWrap = root.querySelector('[data-hot-main-image-wrap]');
  var mainImage = root.querySelector('[data-hot-main-image]');
  var thumbs = root.querySelectorAll('[data-hot-thumb]');
  var variantSelect = root.querySelector('[data-hot-variant-select]');
  var qtyInput = root.querySelector('[data-hot-qty-input]');
  var atcButton = root.querySelector('[data-hot-add-to-cart]');
  var atcLabel = root.querySelector('[data-hot-atc-label]');
  var priceEl = root.querySelector('[data-hot-price]');
  var urgencyEl = root.querySelector('[data-hot-urgency]');
  var optionGroups = root.querySelectorAll('[data-hot-option-index]');
  var nativeCartAdd = root.querySelector('[data-hot-native-cart-add]');
  var nativeCartAddBtn = root.querySelector('[data-hot-native-cart-add-btn]');

  var productData = null;

  fetch('/products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (data) { productData = data; });

  var thumbList = Array.prototype.slice.call(thumbs);
  var currentImageIndex = 0;
  var preloadedUrls = {};

  function preloadGalleryImages() {
    thumbList.forEach(function (thumb) {
      var url = thumb.getAttribute('data-full');
      if (!url || preloadedUrls[url]) return;
      preloadedUrls[url] = true;
      var img = new Image();
      img.src = url;
    });
  }

  if (window.requestIdleCallback) {
    window.requestIdleCallback(preloadGalleryImages, { timeout: 2000 });
  } else {
    setTimeout(preloadGalleryImages, 300);
  }

  function goToImage(index) {
    if (!thumbList.length) return;
    if (index < 0) index = thumbList.length - 1;
    if (index >= thumbList.length) index = 0;
    currentImageIndex = index;

    thumbList.forEach(function (t) { t.classList.remove('is-active'); });
    var activeThumb = thumbList[index];
    activeThumb.classList.add('is-active');
    mainImage.src = activeThumb.getAttribute('data-full');

    if (activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  thumbList.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      goToImage(index);
    });
  });

  if (mainImageWrap && thumbList.length > 1) {
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var touchEndY = 0;

    mainImageWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    mainImageWrap.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      var deltaX = touchEndX - touchStartX;
      var deltaY = touchEndY - touchStartY;

      if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
        if (deltaX < 0) {
          goToImage(currentImageIndex + 1);
        } else {
          goToImage(currentImageIndex - 1);
        }
      }
    }, { passive: true });
  }

  var qtyMinus = root.querySelector('[data-hot-qty-minus]');
  var qtyPlus = root.querySelector('[data-hot-qty-plus]');
  if (qtyMinus) qtyMinus.addEventListener('click', function () {
    qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
  });
  if (qtyPlus) qtyPlus.addEventListener('click', function () {
    qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
  });

  function getSelectedOptions() {
    var selected = [];
    optionGroups.forEach(function (group) {
      var active = group.querySelector('.hot-swatch.is-selected');
      selected.push(active ? active.getAttribute('data-hot-option-value') : null);
    });
    return selected;
  }

  function findMatchingVariant(selected) {
    if (!productData) return null;
    return productData.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      return selected.every(function (val, i) { return val === null || opts[i] === val; });
    });
  }

  function updateUI(variant) {
    if (!variant) return;
    variantSelect.value = variant.id;

    priceEl.querySelector('.hot-price__current').textContent = formatMoney(variant.price);

    var compareEl = priceEl.querySelector('.hot-price__compare');
    var badgeEl = priceEl.querySelector('.hot-price__badge');
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'hot-price__compare';
        priceEl.appendChild(compareEl);
      }
      compareEl.textContent = formatMoney(variant.compare_at_price);

      var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      if (!badgeEl) {
        badgeEl = document.createElement('span');
        badgeEl.className = 'hot-price__badge';
        priceEl.appendChild(badgeEl);
      }
      badgeEl.textContent = pct + '% off';
    } else {
      if (compareEl) compareEl.remove();
      if (badgeEl) badgeEl.remove();
    }

    if (urgencyEl) {
      if (variant.inventory_management && variant.inventory_quantity <= 10 && variant.inventory_quantity > 0) {
        urgencyEl.textContent = 'Only ' + variant.inventory_quantity + ' left — each piece is hand-shaped in small batches';
        urgencyEl.style.display = '';
      } else {
        urgencyEl.style.display = 'none';
      }
    }

    if (variant.available) {
      atcButton.removeAttribute('disabled');
      atcLabel.textContent = 'Add to Cart';
    } else {
      atcButton.setAttribute('disabled', 'disabled');
      atcLabel.textContent = 'Sold Out';
    }

    if (nativeCartAdd) {
      nativeCartAdd.setAttribute('xo-product-id', variant.id);
      if (variant.available) {
        nativeCartAdd.removeAttribute('xo-disabled');
      } else {
        nativeCartAdd.setAttribute('xo-disabled', '');
      }
    }

    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (productData && productData.currency) || 'PKR' });
  }

  optionGroups.forEach(function (group) {
    group.querySelectorAll('.hot-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.hot-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var selected = getSelectedOptions();
        var variant = findMatchingVariant(selected);
        if (variant) updateUI(variant);
      });
    });
  });

  // Route the actual "add" action through the theme's own xo-cart-add
  // component (the same one used on product cards elsewhere, which
  // correctly refreshes the cart badge/drawer) instead of a custom fetch.
  // Since that component only adds quantity 1 per activation, we trigger
  // it once per unit of quantity requested, waiting for each to resolve
  // (via the cart badge actually changing) before firing the next, so
  // quantities greater than 1 still end up correct in the cart.
  function waitForCartCountChange(previousCount, timeoutMs) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = setInterval(function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (settled) return;
            if (cart.item_count !== previousCount) {
              settled = true;
              clearInterval(timer);
              resolve(cart.item_count);
            }
          })
          .catch(function () {});
      }, 250);
      setTimeout(function () {
        if (settled) return;
        settled = true;
        clearInterval(timer);
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          resolve(cart.item_count);
        }).catch(function () { resolve(previousCount); });
      }, timeoutMs || 4000);
    });
  }

  function addOneUnit() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var before = cart.item_count;
        nativeCartAddBtn.click();
        return waitForCartCountChange(before, 4000);
      });
  }

  function addQuantitySequentially(remaining) {
    if (remaining <= 0) return Promise.resolve();
    return addOneUnit().then(function () {
      return addQuantitySequentially(remaining - 1);
    });
  }

  var form = root.querySelector('[data-hot-form]');
  if (form && nativeCartAdd && nativeCartAddBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qty = Math.max(1, parseInt(qtyInput.value || '1', 10));
      atcLabel.textContent = 'Adding…';
      atcButton.setAttribute('disabled', 'disabled');

      addQuantitySequentially(qty)
        .then(function () {
          atcLabel.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('hot:cart:updated'));
          setTimeout(function () {
            atcLabel.textContent = 'Add to Cart';
            atcButton.removeAttribute('disabled');
          }, 1200);
        })
        .catch(function () {
          atcLabel.textContent = 'Try again';
          atcButton.removeAttribute('disabled');
        });
    });
  }
})();

/* ===== hot-product-reviews ===== */
(function () {
  var container = document.querySelector('[data-hot-reviews]');
  if (!container) return;

  var pagerBtns = container.querySelectorAll('[data-hot-page-btn]');
  var nextBtn = container.querySelector('[data-hot-page-next]');
  var cards = container.querySelectorAll('[data-hot-review-page]');
  var totalPages = pagerBtns.length;
  var currentPage = 1;

  function showPage(page) {
    currentPage = page;
    cards.forEach(function (card) {
      var cardPage = parseInt(card.getAttribute('data-hot-review-page'), 10);
      card.hidden = cardPage !== page;
    });
    pagerBtns.forEach(function (btn) {
      var btnPage = parseInt(btn.getAttribute('data-hot-page-btn'), 10);
      btn.classList.toggle('is-active', btnPage === page);
    });
    container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  pagerBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      showPage(parseInt(btn.getAttribute('data-hot-page-btn'), 10));
    });
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      var next = currentPage + 1;
      if (next > totalPages) next = 1;
      showPage(next);
    });
  }
})();

/* ===== hot-cart-savings ===== */
(function () {
  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PKR'
    });
  }

  function computeSavings(cart) {
    var savings = 0;
    cart.items.forEach(function (item) {
      var title = (item.variant_title || item.title || '');
      var lineTotal = item.final_price * item.quantity;
      if (/pair/i.test(title)) {
        savings += lineTotal * 0.02;
      } else if (/single/i.test(title)) {
        savings += lineTotal * 0.05;
      }
    });
    return savings;
  }

  var renderToken = 0;

  function render() {
    var box = document.querySelector('[data-hot-cart-savings]');
    var textEl = document.querySelector('[data-hot-cart-savings-text]');
    var linkEl = document.querySelector('[data-hot-cart-savings-link]');
    if (!box || !textEl) return;

    if (box.getAttribute('data-offer-enabled') !== 'true') {
      box.hidden = true;
      return;
    }

    var myToken = ++renderToken;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (myToken !== renderToken) return; // a newer render has since started

        if (!cart.items || cart.items.length === 0) {
          box.hidden = true;
          return;
        }
        var savings = computeSavings(cart);
        if (savings <= 0) {
          box.hidden = true;
          return;
        }

        var discountedTotal = cart.total_price - savings;

        textEl.innerHTML =
          'Pay the full amount via bank deposit and your total would be <strong>' + formatMoney(discountedTotal) + '</strong> instead of ' + formatMoney(cart.total_price) + '. Choose the bank deposit payment method on the next page (checkout) to avail the discount.';

        if (linkEl) {
          var waNumber = linkEl.getAttribute('data-whatsapp-number');
          var message = encodeURIComponent("Hi! I'd like to pay via bank deposit for my order — sharing a screenshot of my cart.");
          linkEl.href = 'https://wa.me/' + waNumber + '?text=' + message;
          linkEl.hidden = false;
        }

        box.hidden = false;
      })
      .catch(function () {
        if (myToken === renderToken) box.hidden = true;
      });
  }

  render();
  document.addEventListener('hot:cart:updated', render);

  var debounceTimer = null;
  function scheduleRender() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(render, 250);
  }

  function observeCartContainer() {
    var container =
      document.getElementById('shopify-section-cart') ||
      document.querySelector('.xo-cart-mini-content__successfully') ||
      document.body;

    var observer = new MutationObserver(scheduleRender);
    observer.observe(container, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartContainer);
  } else {
    observeCartContainer();
  }
})();
